import { useIntl } from 'react-intl';
import { Descriptions, Skeleton } from 'antd';

import { Part } from '@/core/domain/operational/Parts/Parts.types';

interface PartDetailsDescriptionProps {
  part?: Part;
  isLoading: boolean;
}

function PartDetailsDescription({
  part,
  isLoading,
}: PartDetailsDescriptionProps) {
  const intl = useIntl();

  return (
    <Skeleton active loading={isLoading}>
      <Descriptions
        title={part?.name}
        column={{ xs: 1, md: 3, lg: 4, xxl: 4 }}
        labelStyle={{ fontWeight: 'bold' }}
      >
        <Descriptions.Item
          label={intl.formatMessage({ id: 'parts.entity.subGroup' })}
        >
          {part?.subGroup?.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.formatMessage({ id: 'parts.entity.manufacturer' })}
        >
          {part?.manufacturer?.name}
        </Descriptions.Item>
        <Descriptions.Item
          label={intl.formatMessage({ id: 'parts.entity.unit' })}
        >
          {part?.unit}
        </Descriptions.Item>
      </Descriptions>
    </Skeleton>
  );
}

export default PartDetailsDescription;
